import { optional, optionalQueryBoolean, string, z, zodLess } from '@kaiizen/zod-less';

const limitSchema = z.coerce.number().int().min(1);

export const PropertySearchQuerySchema = zodLess({
  search: string,
  limit: optional(limitSchema),
  includeArchived: optionalQueryBoolean.meta({ description: 'Include archived properties alongside active properties.', example: true }),
});

export const ListSearchQuerySchema = zodLess({
  search: optional(string),
});

export const ArchivedListSearchQuerySchema = zodLess({
  archived: optionalQueryBoolean,
  search: optional(string),
});
